import API_ROUTES from "app/constants/routes/api";
import { setApiLoader } from "app/store/state/admin/action";
import { loaderFlag, setPopUpMessageData } from "app/store/state/jobs/action";
import { getItem, setNonLoginSession } from "app/utils/session";
import axios from "axios";
import get from "lodash/get";
import { configData } from '../utils/config';
import { languageFn } from "app/common/components/customFunction";

const FCMToken = localStorage.getItem("FCMToken")
export const infoBean = {
    androidId: "string",
    androidVersion: "string",
    appName: "GenbaNext_Daikin_JP",
    appSignature: "string",
    appVersion: "string",
    deviceModel: "string",
    fcmId: FCMToken,
    manufacturer: "string",
    platform: "WEB",
    userAgent: "Web",
};

export const generateNonLoginAuth = () => {
    const FCMToken = localStorage.getItem("FCMToken")
    infoBean.fcmId = FCMToken
    return axios.post(API_ROUTES.LANDING, {
        androidUniqueId: `${Date.now()}`,
        infoBean,
    });
};

export const generateLoginAuth = (credentials, setLoadingFlag) => {
    const nonLoginAuthToken = getItem("nonLoginAuthToken");
    const { username, password, FCMToken } = credentials;
    const { APP_NAME, country } = configData;
    const language = getItem("lang")

    return new Promise((resolve, reject) => {
        infoBean.fcmId = FCMToken
        if (nonLoginAuthToken) {
            axios
                .post(API_ROUTES.LOGIN, {
                    infoBean,
                    nonLoginAuthToken,
                    password,
                    username,
                }, {
                    headers: {
                        'APP_NAME': APP_NAME,
                        'country': country,
                        'Accept-language': languageFn(language), ...configData?.authorization
                    }
                })
                .then((res) => {
                    setLoadingFlag(false)
                    const resData = get(res, "data.data", undefined);
                    const errorMsg = get(res, "data.error.errorMsg", undefined);
                    if (resData) resolve(res);
                    else {
                        const errorCode = get(res, "data.error.errorCode");
                        if (errorCode === 32) {
                            generateNonLoginAuth().then((res) => {
                                setNonLoginSession(res);
                                const reviseNonLoginAuthToken = getItem(
                                    "nonLoginAuthToken"
                                );
                                axios.post(API_ROUTES.LOGIN, {
                                    infoBean,
                                    nonLoginAuthToken: reviseNonLoginAuthToken,
                                    password,
                                    username,
                                }, {
                                    headers: {
                                        'APP_NAME': APP_NAME,
                                        'country': country,
                                        'Accept-language': languageFn(language), ...configData?.authorization
                                    }
                                })
                                    .then((r) => resolve(r))
                                    .catch((e) => reject(e));
                            });
                        } else if (errorMsg) {
                            window.redux(setPopUpMessageData({ modal: true, message: [errorMsg] }))
                            window.redux(setApiLoader(false))
                            window.redux(loaderFlag(false))
                        }
                        else reject();
                    }
                })
                .catch((err) => {
                    setLoadingFlag(false)
                    window.redux(setPopUpMessageData({ modal: true, message: [err] }))
                });
        } else {
            generateNonLoginAuth().then((res) => {
                setNonLoginSession(res);
                const reviseNonLoginAuthToken = getItem("nonLoginAuthToken");
                axios
                    .post(API_ROUTES.LOGIN, {
                        infoBean,
                        nonLoginAuthToken: reviseNonLoginAuthToken,
                        password,
                        username,
                    }, {
                        headers: {
                            'APP_NAME': APP_NAME,
                            'country': country,
                            'Accept-language': languageFn(language), ...configData?.authorization
                        }
                    })
                    .then((r) => resolve(r))
                    .catch((e) => reject(e));
            });
        }
    });
};

export const logout = (refreshToken) => {
    const { APP_NAME, country } = configData;
    const language = getItem("lang")

    return axios.post(API_ROUTES.LOGOUT, {
        refreshToken,
    }, {
        headers: {
            'APP_NAME': APP_NAME,
            'country': country,
            'Accept-language': languageFn(language), ...configData?.authorization
        }
    });
};

export const refreshAuth = () => {
    const refreshToken = getItem("refresh_token");
    const FCMToken = localStorage.getItem("FCMToken")
    infoBean.fcmId = FCMToken;
    const { APP_NAME, country } = configData;
    const language = getItem("lang")

    return axios.post(API_ROUTES.REFRESH_TOKEN, {
        refreshToken,
        infoBean,
    }, {
        headers: {
            'APP_NAME': APP_NAME,
            'country': country,
            'Accept-language': languageFn(language), ...configData?.authorization
        }
    });
};
